import { TSMInstance } from '@/api/instance'

const url = process.env.VUE_APP_BASE_API_URL

export async function getClipInfo () {
  const response = await TSMInstance.get(`${url}api/TopClip`)
  return response.data
}

export async function getBroadcasterChoice () {
  const response = await TSMInstance.get(`${url}api/TopClip/Broadcaster`)
  return response.status === 204 ? null : response.data
}

export async function setSettings (settings) {
  const response = await TSMInstance.put(`${url}api/TopClip/Settings`, settings)
  return response.data
}
